import { Typography } from '@mui/material'

const HelpText = () => {

  return (
    <div className='p-5'>
      <Typography variant='h5' className='pb-5'>New Support Request</Typography>
      <p>Select [NEW SUPPORT REQUEST] from the top menu and complete the form. We'll get 
        back to you as soon as awe can.
      </p>

    </div>
  )
}

export default HelpText